// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-primary[data-v-72b208e0]{background-color:#b082f9}.fg-secondary[data-v-72b208e0]{color:#fff}.bg-error[data-v-72b208e0]{background-color:#fca2ae}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
